export const reduceReadUserProfileRequest = (state) => ({
  ...state,
  ui: { ...state.ui, isFetchingUserProfile: true },
});

// sets user profile and sets fetching user profile flag to false
export const reduceReadUserProfileSuccess = (state, { payload }) => ({
  ...state,
  base: { ...state.base, ...payload },
  ui: { ...state.ui, isFetchingUserProfile: false },
});

export const reduceReadUserProfileFailure = (state) => ({
  ...state,
  ui: { ...state.ui, isFetchingUserProfile: false },
});
